// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store/index';
import $ from 'jquery'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min'
import './common/css/index.css'
import './common/stylus/icon.styl'
import  FastClick  from  'fastclick'
//import VConsole from 'vconsole'
import {
	router
} from './router'
import axios from './axios/http.js'
// Vue.use(iView)
Vue.prototype.axios = axios;
//let vConsole = new VConsole(); // 初始化
Vue.config.productionTip = false;
$(function() {
	FastClick.attach(document.body);
	document.body.addEventListener('touchstart', function(){ });
});

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	axios,
	template: '<App/>',
	components: {
		App
	}
})



// WEBPACK FOOTER //
// ./src/main.js